import { delayRepayRoute } from './helpers';
import { DelayRepayPages } from '../../../../src/constants/AppConstants';

export default delayRepayRoute(DelayRepayPages.PAYMENT, {
    getComponent(location, cb) {
        require.ensure([], (require) => {
            cb(null, require('../../components/delayRepay/Payment').default);
        }, 'delayrepay-payment');
    }
});
